import { AfterViewChecked, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, debounceTime, Observable, Subscription } from 'rxjs';
import { BENEFITS_KEY } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { modifyTitle } from '../customer-jobs/customer-jobs.component';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { CustomerSearchComponent } from '../customer-search/customer-search.component';
import { ManageSlotComponent } from '../manage-slot/manage-slot.component';
import { MtaFilterPipe } from 'src/app/pipe/name-filter.pipe';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-customer-interaction',
  standalone: true,
  imports: [CommonModule, NgxDatatableModule, PlanCardComponent, CustomerSearchComponent,
ManageSlotComponent, MtaFilterPipe, TimezoneDatePipe, TitleCasePipe, NodataFoundComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './customer-interaction.component.html',
  styleUrls: ['./customer-interaction.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class CustomerInteractionComponent extends FormValidation implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('sortTable') table: any;
  public listToShow: Array<any> = [];
  PLANMAX: number = 0;
  AVAILABLE: number = 0;
  ALLOCATED: number = 0;
  totalUsers: number = 0;
  userPayload: any = {
    limit: 10,
    page: 0,
    statusList: null,
    groupType: "LISTING"
  }
  textFields: Array<Partial<TEXT_FIELDS>>;
  activate = new EventEmitter();
  refreshSubcription: Subscription;
  filterSubscription: Subscription;
  searchSubscription: Subscription;
  public slotData = new BehaviorSubject([]);
  slotPayload: any = {
    type: "ACTIVE_INTERACTIONS",
    limit: 10,
    page: 0,
    searchAfterKey: null,
    statusList: ["ACTIVE", "INACTIVE", "BLOCKED"],
    groupType: "MANAGE"
  }

  MemberShipType: any;
  openSlotSubscription: Subscription;
  prevSearchAfterKey: any;
  stopScroll: boolean = false;
  slotModalOpen: boolean = false;
  slotPlanDetails: any = {};
  businessData: any;
  allocationCards = [
    {
      id: "",
      name: "Plan Max",
      value: 0
    },
    {
      id: "SLOT_ALLOCATED",
      name: "Allocated",
      value: 0
    },
    {
      id: "SLOT_MAX",
      name: "Available",
      value: 0
    },
  ];
  slotAllocatedCards = [];
  scroll: boolean = false;
  editMode: boolean = false;

  constructor(private util: UtilService,
    private api: ApiService,
    private modalService: BsModalService,
    private _api_service: ApiService,
    private router: Router,
    private _activated_route: ActivatedRoute,
    private excel: ExcelService,
    private customerService: CustomerService,
    private gigsumoService: GigsumoService,
    private renderer: Renderer2, private el: ElementRef,
  ) {
    super();

    this._activated_route.parent.data.subscribe(res => {
      this.businessData = res.data;
      this.MemberShipType = this.businessData.plan
      this.role = this.businessData.role;
      this.slotPayload.businessId = this.businessData.id;
      this.slotPayload.email = this.businessData.businessEmail;

    });

    this.textFields = [
      { label: "User Name", key: "fullName", value: null, type: "STRING" },
      { label: "Email ID", key: "username", value: null, type: "STRING" },
      { label: "Gigsumo ID", key: "gigsumoNo", value: null, type: "STRING" },
      { label: "Role", key: "userType", value: null, type: "STRING" },
      { label: "Allocated", key: "userType", value: null, type: "STRING" },
      { label: "Available", key: "userType", value: null, type: "STRING" },
      { label: "Start Date", key: "createdOn", value: null, type: "DATE" },
      { label: "Last Active", key: "lastLoggedIn", value: null, type: "DATE" },
      { label: "Plan Access", key: "planAccessStatus", value: null, type: "STRING" },
      { label: "Status", key: "userStatus", value: null, type: "STRING" },
    ];

    this.refreshSubcription = this.customerService.getRefreshKey().subscribe((ress: any) => {
      if (ress === "interaction") {
        this.ngOnInit()
      }
    });


    this.filterSubscription = this.customerService.getFilterValue().subscribe(res => {
      if (res.key === 'interaction') {
        this.userPayload.page = 0;
        this.userPayload.enabled = res.value.enabled;
        this.userPayload.statusList = res.value.status != null ? [res.value.status] : null;
        this.userPayload.roleList = res.value.role != null ? [res.value.role] : null;
        this.userPayload.planAccessStatus = res.value.planAccessStatus != null ? [res.value.planAccessStatus] : null;
        this.userPayload.searchContent = null;
        if (res.value.status == null) {
          this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"];
        }
        this.customerService.setFilterPayload(this.userPayload);
        this.fetchData();
      }
    });


    this.searchSubscription = this.customerService.getSearchValue().pipe(
      debounceTime(1000),
    ).subscribe(response => {
      if (response.key === "interaction") {
        if (response.value.status == null) {
          this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"];
        }

        this.userPayload.page = 0;
        this.userPayload.searchContent = response.value;
        this.fetchData();
      }
    });


    this.openSlotSubscription = this.customerService.getSlotModal().subscribe(res => {
      if (res.key === "interaction") {
        this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"];
        this.slotPlanDetails = res.value;
        this.editMode = false;
        this.fetchSlotData();
      }
    });

  }

  ngOnInit(): void {
    this.userPayload.statusList = ["ACTIVE", "INACTIVE", "BLOCKED"];
    this.fetchData();
  }
  onSort(event) {
    const currentPage = this.userPayload.page;
    this.table.offset = currentPage;
  }

  scrollSynced = false; // Flag to prevent multiple bindings
  bodyScrollUnlistener: () => void; // To store the unlistener for clean-up
  resizeUnlistener: () => void; // To store resize unlistener

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      // If it's not Firefox, no need for custom scroll handling
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {
      // Clean up any previous listeners to avoid duplicates
      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }

      // Scroll listener to sync body and header scrolls
      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10)); // Throttle the scroll event to improve performance

      // Listener for window resize to ensure the header remains aligned
      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true; // Mark scroll syncing as done
    }
  }

  // Browser detection function to check if the browser is Firefox
  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  ngOnDestroy(): void {

    if (this.refreshSubcription) {
      this.refreshSubcription.unsubscribe();
    }

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    if (this.openSlotSubscription) {
      this.openSlotSubscription.unsubscribe();
    }

    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }
    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }

  async getUserPlanDetails() {
    this.util.startLoader();
    try {
      let planBenefits: any = await this.api.lamdaFunctionsget('findAllUsersBenefits/' + localStorage.getItem('userId'));
      if (planBenefits.data) {
        this.util.stopLoader();
      }
    } catch (error) {

    }
  }


  public selected = [];
  nextPage(data: any) {
    this.userPayload.page = data.offset;
    if (this.userPayload.page == 0) {
      this.userPayload.page = 0;
    }
    this.userPayload.limit = 10;
    this.fetchData();
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
  role: any
  getCustomerUsersList(payload: Object): Observable<any> {
    return this._api_service.create('subscription/findEmployeeBenefitsAllocation', payload);
  }

  getUserInteractionList(payload: Object): Observable<any> {
    return this._api_service.create('subscription/findUserWithBenefitAllocation', payload);
  }

  //   set allocation details
  setAllocationDetails(plan: any) {
    if (plan && plan.benefitsUsages) {
      const found = plan.benefitsUsages.find(x => (x.benefitKey as BENEFITS_KEY) === 'ACTIVE_INTERACTIONS');
      if (found) {
        this.PLANMAX = found.actual;
        this.AVAILABLE = found.available;
        this.ALLOCATED = found.utilized;


        this.allocationCards[0].value = this.PLANMAX;
        this.allocationCards[1].value = this.ALLOCATED;
        this.allocationCards[2].value = this.AVAILABLE;
        this.slotAllocatedCards = structuredClone(this.allocationCards);

      }
    }
  }

  //   benefit for non-superadmin
  setUserBenefitDetails(plan: any) {
    if (plan && plan.benefitsUsageAndBalance) {
      this.PLANMAX = plan.benefitsUsageAndBalance.actual;
      this.AVAILABLE = plan.benefitsUsageAndBalance.available;
      this.ALLOCATED = plan.benefitsUsageAndBalance.actual;

      this.allocationCards[0].value = this.PLANMAX;
      this.allocationCards[1].value = this.ALLOCATED;
      this.allocationCards[2].value = this.AVAILABLE;
    }
  }

  // Reusable error handling function
  handleError(error: any) {
    console.error('Subscribe Error:', error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "An error occurred while fetching data. Please try again later.",
    });
  }


  fetchData() {
    this.util.startLoader();
    this.userPayload.type = "ACTIVE_INTERACTIONS";
    if (this.role === 'SUPERADMIN' && ['Starter', 'Growth', 'ScaleX'].includes(this.MemberShipType)) {
      this.userPayload.businessId = this.businessData.id;
      this.userPayload.email = this.businessData.email;

      this.getCustomerUsersList(this.userPayload)
        .subscribe({
          next: (res) => {
            this.util.stopLoader();
            if (res && res.code === GigsumoConstants.SUCESSCODE) {
              this.listToShow = res.data.customerUserAllocationList;
              this.totalUsers = res.data.totalUsers;

              // Process the list and remove underscores from userType
              this.listToShow.forEach(user => {
                if (user.userStatus !== "INITIATED") {
                  user.userType = user.userType.replaceAll("_", " ");
                }
                // user.userType = (user.userType === GigsumoConstants.MTA || user.userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION) ?  GigsumoConstants.MANAGER : user.userType;
              });

              this.excel.setCount(this.totalUsers);
              this.customerService.setUserData(this.listToShow);

              // Set allocation details
              this.setAllocationDetails(res.data.customerPlanUsage);
            }
          },
          error: (error) => this.handleError(error)
        });
    } else {
      this.userPayload.userId = localStorage.getItem('userId');

      this.getUserInteractionList(this.userPayload)
        .subscribe({
          next: (res) => {
            this.util.stopLoader();
            if (res && res.code === GigsumoConstants.SUCESSCODE) {

              this.listToShow = Array.isArray(res.data.userWithBenefit) ? res.data.userWithBenefit : [res.data.userWithBenefit];
              this.totalUsers = 1;
              this.listToShow.forEach(user => {
                if (user.userStatus !== "INITIATED") {
                  user.userType = user.userType.replaceAll("_", " ");
                }
              });
              this.excel.setCount(this.totalUsers);
              this.customerService.setUserData([this.listToShow]);
              this.setUserBenefitDetails(res.data.userWithBenefit);
            }
          },
          error: (error) => this.handleError(error)
        });
    }
  }

  convertToTitleCase(str) {
    return str
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  fetchSlotData() {
    this.util.startLoader();
    this.getCustomerUsersList(this.slotPayload)
      .subscribe({
        next: (response) => {
          if (response) {
            this.util.stopLoader();
          }
          if (response && response.code === GigsumoConstants.SUCESSCODE) {
            const users = response.data.customerUserAllocationList;
            users.forEach(x => {
              x.userType = this.convertToTitleCase(x.userType);
            })
            const searchKey = response.data.searchAfterKey;

            if (users) {
              const current = users;
              const exist = this.slotData.getValue();
              let sortDuplicates = this.gigsumoService.removeDuplicatesKey([...exist, ...current], 'userId')
              this.slotData.next(sortDuplicates);
            }

            if (users != null && (users.length === 0 || JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))) {
              this.stopScroll = true;
            }

            this.prevSearchAfterKey = searchKey;
            this.slotModalOpen = true;
            this.scroll = false;
          }
        },
        error: (error) => {
          console.error('Subscribe Error:', error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching data. Please try again later.",
          });
        }
      });
  }


  handleInvalidSession() {
    Swal.fire({
      icon: "info",
      title: "Invalid session",
      text: "Sorry, your session has expired. We are routing you to login page.",
      showConfirmButton: false,
      timer: 5000,
    }).then(() => {
      localStorage.clear();
      this.router.navigate(['/auth/login']);
      this.util.stopLoader();
      Swal.close();
    });
  }

  openViewModal(datas: any) {
    this.textFields = modifyTitle(this.textFields, this.MemberShipType === "Free" ? true : false);


    if (datas) {
      Object.keys(datas).map(key => {
        this.textFields.forEach(v => {

          if (v.label === "Allocated" || v.label === 'Available') {
            v.value = this.curryObject(datas, 'benefitsUsageAndBalance')(v.label === "Allocated" ? "actual" : "available");
            return;
          }

          if (v.key === "planAccessStatus") {
            v.value = datas[v.key] === "ACTIVE" ? "Given" : "Not given";
            return;
          }

          if (v.key === "userType") {
            v.value = datas[v.key] ? this.util.userAlias(datas[v.key]) : "N/A";
            return;
          }

          if (v.key == key) {
            v.value = datas[key];
          }

        });
      });
    }

    if (this.textFields) {
      this.openView("Interaction Credits", this.textFields, this.modalService, this.util);
    }

  }

  async openEditModal(row) {
    this.util.startLoader();
    let planData = await this.customerService.getupdatedplans(this.businessData.id);
    this.slotPlanDetails = planData
    this.slotData.next([row]);
    this.slotModalOpen = true;
    this.editMode = true;
    this.util.stopLoader();
  }

  onScroll() {
    if (!this.stopScroll) {
      this.scroll = true;
      this.slotPayload = {
        ...this.slotPayload,
        searchAfterKey: this.prevSearchAfterKey
      }
      this.fetchSlotData();
    }
  }

  onClose(d) {
    this.resetSlotData();
  }


  onSucess(d) {
    if (d === "SUCCESS") {
      this.resetSlotData();
    }
  }


  resetSlotData() {
    this.slotData.next([]);
    this.slotPayload.searchAfterKey = null;
    this.prevSearchAfterKey = null;
    this.slotPayload.searchContent = "";
    this.slotModalOpen = false;
    this.editMode = false;
    this.stopScroll = false;
  }


  onSearch(v) {
    this.slotPayload.searchAfterKey = null;
    this.prevSearchAfterKey = null;
    this.stopScroll = false;
    this.slotPayload.searchContent = v;
    this.slotData.next([]);
    this.fetchSlotData();
  }
}
